<div *ngIf="loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form mt-15">
  <div *ngIf="model" class="form-group">
    <label class="form-label">Title</label>
    <input [(ngModel)]="model.title" formControlName="title" type="text" class="form-control mb-20" required>
    <input-errors [control]="form.controls.title" [service]="validationService"></input-errors>
  </div>
  <app-lnt-form (onLoad)="onLoadForm()" [showButtons]="false" [allowFlashCall]="true"></app-lnt-form>
  <br>
  <div class="hr-line-dashed"></div>
  <div class="step-buttons">
    <a *ngIf="backButtonShow" (click)="onTestCaseTemplateSave.emit(false)" class="btn btn-outline-dark">Cancel</a>
    <button *ngIf="form" type="submit" [disabled]="!form.valid" class="btn btn-primary m-b">Apply</button>
  </div>
</form>
